import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const StoreContext = createContext(null);
export const useStore = () => useContext(StoreContext);

export function StoreProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [content, setContent] = useState({});
  const [categories, setCategories] = useState([]);
  const [collections, setCollections] = useState([]);

  const reload = async () => {
    try {
      const [s, c, cat, col] = await Promise.all([
        api.get("/settings/public"),
        api.get("/content"),
        api.get("/categories"),
        api.get("/collections"),
      ]);
      setSettings(s.data || {});
      setContent(c.data || {});
      setCategories(cat.data || []);
      setCollections(col.data || []);
    } catch (e) { /* ignore */ }
  };

  useEffect(() => { reload(); }, []);

  return (
    <StoreContext.Provider value={{ settings, content, categories, collections, reload }}>
      {children}
    </StoreContext.Provider>
  );
}

export const money = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export function waLink(number, message) {
  const num = (number || "").replace(/\D/g, "");
  return `https://wa.me/${num}?text=${encodeURIComponent(message || "")}`;
}
